import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { admissionOfHpvryPatientscomponentservices } from '../../../services/admissionOfHpvryPatients.services';
import { onlinesmsservices } from '../../../services/onlinesms.services';
import { TestCost } from '../../../models/admissionOfHpvryPatients.component.models/testCost';
import { Csave } from '../../../models/admissionOfHpvryPatients.component.models/Csave';
import { debug } from 'util';

declare let $: any;

@Component({
  selector: 'admissionOfHpvryPatients',
  templateUrl: 'admissionOfHpvryPatients.component.html'
})
export
  class AdmissionOfHpvryPatientsComponent implements OnInit {
  ListTest: any = [];
  SelectedTestList: any = [];
  testAcceptionFormModel: FormGroup;
  formSaved: boolean = false;
  savedFormData: any = {};
  paymentUrl: string = '';
  submit: any;
  testAcceptionCost: number;
  waiting: boolean = false;
  waitingForSMS: boolean = false;
  

  ngOnInit(): void {
    this.admissionOfHpvryPatientscomponentservices.GetStatusAnswer(2)
      .subscribe((data: TestCost[]) => {    
        debugger;
        console.log(data);
        this.ListTest = data        
      });
    this.admissionOfHpvryPatientscomponentservices.GetTestAcceptationCost().subscribe((data: any) => {
      this.testAcceptionCost = data.AcceptationCost;
    });
  }

  

  FirstName: FormControl = new FormControl('', [
    Validators.required
  ]);
  LastName: FormControl = new FormControl('', [
    Validators.required
  ]);
  Gender: FormControl = new FormControl('');
  PaymentMethod: FormControl = new FormControl(2);
  NationalCode: FormControl = new FormControl('', [
    Validators.required
  ]);
  mobile: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8)
  ]);
  Address: FormControl = new FormControl('');
  TestReason: FormControl = new FormControl('', [
    Validators.required
  ]);

  day: FormControl = new FormControl('', [
    Validators.max(31)    
  ]);
  month: FormControl = new FormControl('', [
    Validators.max(12)
  ]);
  year: FormControl = new FormControl('', [
    Validators.min(1250)
  ]);

  AcceptionNumber: FormControl = new FormControl(0);

  Birthday: FormGroup = new FormGroup({
    day: this.day,
    month: this.month,
    year: this.year
  });

  smsCode: FormControl = new FormControl('', []);

  hpvForm: FormGroup = this.formBuilder.group({
    FirstName: this.FirstName,
    LastName: this.LastName,
    NationalCode: this.NationalCode,
    Birthday: this.Birthday,
    Address: this.Address,
    mobile: this.mobile,
    Gender: this.Gender,
    TestReason: this.TestReason,
    AcceptionNumber: this.AcceptionNumber,
    smsCode: this.smsCode
  });
 
  
  constructor(private formBuilder: FormBuilder, private admissionOfHpvryPatientscomponentservices: admissionOfHpvryPatientscomponentservices,
    private onlinesmsservices: onlinesmsservices) { }

  //get tescAcceptionForm(): FormArray {
  //  return this.testAcceptionFormModel.get("TestCaseList") as FormArray
  //}
  pay() {
    var date = this.hpvForm.controls['Birthday'].value;
    this.hpvForm.controls["Birthday"].setValue(date.year + "/" + date.month + "/" + date.day);
  }

  testClicked(e, selectedTest) {
    if (e.target.checked) {
      this.SelectedTestList.push(selectedTest);
    }
    else {
      let index = 0;
      for (var item of this.SelectedTestList) {
        if (item.Id == selectedTest.Id) {
          this.SelectedTestList.splice(index, 1);          
        }
        index++;
      }  
    }
  }
  onKeydownMain(e) {
   
    if (isNaN(e.key)) {
      

      return false
    }
    else {
      return true
    }
  }
  checkNationalCode() {
    var code = this.hpvForm.controls["NationalCode"].value;
    if (!code || code == '') {
      return false;
    }

    var l = code.length;
    if (!/^\d{10}$/.test(code) ||
      code == '0000000000' ||
      code == '1111111111' ||
      code == '2222222222' ||
      code == '3333333333' ||
      code == '4444444444' ||
      code == '5555555555' ||
      code == '6666666666' ||
      code == '7777777777' ||
      code == '8888888888' ||
      code == '9999999999') {

      return false;
    }

    if (l < 8 || parseInt(code, 10) == 0) {
      return false;
    }
    code = ('0000' + code).substr(l + 4 - 10);
    if (parseInt(code.substr(3, 6), 10) == 0) {
      return false;
    }
    var c = parseInt(code.substr(9, 1), 10);
    var s = 0;
    for (var i = 0; i < 9; i++) {
      s += parseInt(code.substr(i, 1), 10) * (10 - i);
    }
    s = s % 11;
    return true;
  };
  
  Submitform() {
   
    if (this.SelectedTestList.length == 0) {
      alert(" لطفا یک گزینه را انتخاب کنید ");
     
      return;
    }
    if (this.checkNationalCode() == false) {
      document.getElementById('nationalirycode').style.display='block'
      return false
    }
    if (this.SelectedTestList.filter(item => item.Id == 4).length > 0 && this.SelectedTestList.length < 2) {
      alert("گزینه نمونه گیری در محال نباید به تنهایی انتخاب شود.");
      return false;
    }
    if (this.PaymentMethod.value == 1 && this.Address.value.length < 10) {
      alert("مقدار آدرس را به درستی و کامل وارد کنید. مقدار آدرس باید حداقل 50 کاراکتر باشد.");
      return false;
    }
    
    var csave = new Csave();
    
    csave.TestCaseList = this.SelectedTestList;
    csave.TestedPerson = this.hpvForm.value;
    csave.TestedPerson.Birthday = `${this.year.value}/${this.month.value}/${this.day.value}`; 
    csave.TestReason = this.TestReason.value;
    csave.PaymentMethod = this.PaymentMethod.value;
    csave.AcceptionNumber = this.AcceptionNumber.value;

    this.waiting = true;

    this.admissionOfHpvryPatientscomponentservices.CreateNew(csave).subscribe(resp => {
      this.waiting = false;
      if (resp) {
        this.savedFormData = resp;
        this.formSaved = true;
        if (this.PaymentMethod.value == 2) {
          alert('اطلاعات شما با موفقیت ذخیره شد. لطفا برای ادامه فرایند پذیرش روی دکمه پرداخت کلیک کنید.');
        }
        else {
          alert('اطلاعات شما با موفقیت ذخیره شد.');
        }
      }
    }); 
  }
  getPriceSum() {
    var sum = 0;
    for (var item of this.SelectedTestList) {
      sum += item.Cost;
    }
    return sum == 0 ? 0: (sum + this.testAcceptionCost);
  }

  getPaymentUrl() {
    var thisSiteUrl ="http://valiasrlab.com";// document.location.origin;
    var fReturnUrlSuccess = thisSiteUrl + `/PaymentSucceeded?key=${this.savedFormData.AcceptionNumber}_${this.NationalCode.value}`;
    var fReturnUrlFailure = thisSiteUrl + '/PaymentFailure';

    return this.admissionOfHpvryPatientscomponentservices.GetAcceptionPaymentUrl(this.savedFormData.Id, fReturnUrlSuccess, fReturnUrlFailure);
  }

  checkForEdit() {
    if (this.NationalCode.value.trim() != '') {
      this.waiting = true;
      this.onlinesmsservices.Getcode(this.NationalCode.value).subscribe(resp => {
        this.waiting = false;
        alert('لطفا کد پیامک شده را وارد کنید.');
        this.waitingForSMS = true;
      });
    }    
  }
  approveSMS() {
    if (this.smsCode.value != '') {
      this.waiting = true;
      this.waitingForSMS = false;
      this.onlinesmsservices.GetAnsweringCorona(this.NationalCode.value, this.smsCode.value).subscribe((resp: any) => {
        this.waiting = false;
        console.log('sms resp: ', resp);
        var birthday = new Date(resp.Birthday);
        this.hpvForm.setValue({
          FirstName: resp.FirstName,
          LastName: resp.LastName,
          NationalCode: resp.NationalCode,
          Birthday: {
            day: birthday.getDate(),
            month: birthday.getMonth() + 1,
            year: birthday.getFullYear()
          },
          Address: resp.Address,
          mobile: resp.Mobile,
          Gender: resp.Gender,
          TestReason: resp.TestReason,
          AcceptionNumber: resp.AcceptionNumber,
          smsCode: ''
        });
        //.................................
        for (var item in resp.TestCases) {
          $(`[test-id=${item}]`).prop('checked', true);
          let testCost = this.ListTest.filter((cost) => cost.TestId == item);
          if (testCost.length > 0) {
            this.SelectedTestList.push(testCost[0]);
          }
        }
      }, err => {
          this.waiting = false;
          console.error('get answering hpv error: ', err);
      });
    }
  }
}
